module.exports = __webpack_public_path__ + "img/day23.40d37732.jpeg";